import * as React from "react"
const IconConnectedPOS = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 24}
        height={props.height || 24}
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <path
            stroke={props.stroke || "#64748B"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M7 18a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm0 0h10m0 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm1-2-5-8m-2 0-5 8m8-10a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"
        />
    </svg>
)
export default IconConnectedPOS
